import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asPushPrompt" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "asPushPrompt_actions" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.853553 0.146447C0.658291 -0.0488155 0.341709 -0.0488155 0.146447 0.146447C-0.0488155 0.341709 -0.0488155 0.658291 0.146447 0.853553L5.79289 6.5L0.146447 12.1464C-0.0488155 12.3417 -0.0488155 12.6583 0.146447 12.8536C0.341709 13.0488 0.658291 13.0488 0.853553 12.8536L6.5 7.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L7.20711 6.5L12.8536 0.853553C13.0488 0.658291 13.0488 0.341709 12.8536 0.146447C12.6583 -0.0488155 12.3417 -0.0488155 12.1464 0.146447L6.5 5.79289L0.853553 0.146447Z",
    fill: "white"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "11",
  viewBox: "0 0 17 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 4L7 10L13 4L16.5 0.5",
    stroke: "white",
    "stroke-width": "1.2"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_modal = _resolveComponent("as-modal")!

  return (_openBlock(), _createBlock(_component_as_modal, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isOpen) = $event)),
    "btn-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "asPushPrompt_title",
          innerHTML: _ctx.title
        }, null, 8, _hoisted_2),
        _createElementVNode("span", {
          class: "asPushPrompt_text",
          innerHTML: _ctx.text
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "asPushPrompt_btn -decline",
            "aria-label": _ctx.$t('NO'),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.declinePush && _ctx.declinePush(...args)))
          }, _hoisted_7, 8, _hoisted_5),
          _createElementVNode("button", {
            class: "asPushPrompt_btn -accept",
            "aria-label": _ctx.$t('yes'),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.enablePush && _ctx.enablePush(...args)))
          }, _hoisted_10, 8, _hoisted_8)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}